<div class="bg-background min-h-screen flex flex-col items-center p-6 pt-12 relative overflow-x-hidden">
<!-- Brand Logo Top Center -->
<div class="mb-8">
<a routerLink="/" class="font-headline font-extrabold tracking-tight text-3xl text-primary">ZAD ERP</a>
</div>

<!-- Centered Sign-In Card -->
<main class="w-full max-w-md bg-surface-container-lowest rounded-xl p-8 architectural-shadow relative">
<!-- Top start Navigation Links -->
<nav class="absolute top-6 end-8 flex gap-4">
<a routerLink="/" class="text-primary font-medium text-sm hover:underline transition-all">Home</a>
</nav>

<!-- Card Header -->
<div class="text-center mt-8 mb-10">
<h2 class="font-headline font-bold text-2xl text-on-surface tracking-tight">Sign in to your account</h2>
</div>

<!-- Form Fields -->
<form class="space-y-6" (submit)="onSubmit($event)">
<!-- Email Field -->
<div class="space-y-2">
<label class="block font-label font-bold text-[10px] tracking-widest text-on-surface-variant uppercase">Email Address *</label>
<div class="relative">
<input class="w-full px-4 py-3 bg-surface-container-low border-none rounded-lg text-on-surface placeholder:text-outline focus:ring-2 focus:ring-surface-tint/40 transition-all outline-none" placeholder="Enter your email" type="email" name="email" [(ngModel)]="email" required/>
</div>
</div>

<!-- Password Field -->
<div class="space-y-2">
<label class="block font-label font-bold text-[10px] tracking-widest text-on-surface-variant uppercase">Password *</label>
<div class="relative flex items-center">
<input class="w-full px-4 py-3 bg-surface-container-low border-none rounded-lg text-on-surface placeholder:text-outline focus:ring-2 focus:ring-surface-tint/40 transition-all outline-none" placeholder="Enter your password" [type]="passwordVisible ? 'text' : 'password'" name="password" [(ngModel)]="password" required/>
<button class="absolute end-4 text-on-surface-variant hover:text-primary transition-colors" type="button" (click)="togglePasswordVisibility()">
<span class="material-symbols-outlined text-[20px]">{{passwordVisible ? 'visibility_off' : 'visibility'}}</span>
</button>
</div>

<!-- Forgot Password Link -->
<div class="flex justify-end mt-1">
<a routerLink="/reset-password" class="text-primary text-xs font-semibold hover:underline">Forgot password?</a>
</div>
</div>

<!-- Sign In Button -->
<div class="pt-4">
<button class="w-full py-4 bg-gradient-to-r from-primary to-primary-container text-on-primary font-headline font-bold text-base rounded-xl shadow-md active:opacity-80 transition-all disabled:opacity-50 disabled:cursor-not-allowed" type="submit" [disabled]="!email || !password">
Sign In
</button>
</div>
</form>

<!-- Card Footer -->
<div class="mt-12 pt-6 border-t border-outline-variant/15 text-center">
<p class="text-on-surface-variant text-sm font-medium">
Don't have an account? 
<a routerLink="/create-account" class="text-primary font-bold ms-1 hover:underline">Sign up</a>
</p>
</div>
</main>
</div>
